<template>
  <div class="d-flex justify-content-start align-items-start nowrap">
    <!-- INVISIBLE AVATAR -->
    <div class="avatar invisible mr-2 d-none d-md-block"></div>
    <!-- INVISIBLE AVATAR -->
    <div class="post-event-section w-100 rounded-5">
      <div class="top-block">
        <!-- EVENT AVATAR -->
        <template v-if="account_type === 'teacher'">
          <div class="avatar avatar-square brand_accent_light_bg">
            <div
              class="span flex-center icon-videocam brand_accent font-24"
            ></div>
          </div>
        </template>

        <template v-if="account_type === 'school'">
          <div class="avatar avatar-square brand_red_light_bg">
            <div
              class="span flex-center icon-video-card brand_red font-24"
            ></div>
          </div>
        </template>

        <template
          v-if="account_type === 'parent' || account_type === 'student'"
        >
          <div class="avatar avatar-square brand_red_light_bg">
            <div
              class="span flex-center icon-video-card brand_red font-24"
            ></div>
          </div>
        </template>

        <!-- EVENT INFO -->
        <div class="homework-info">
          <div class="title color_text font-weight-bold">
            {{ post.reference.title }}
          </div>
          <div class="timing color_grey_dark">
            <span>{{ getDateFormat }}</span>
          </div>

          <!-- EVENT TIMING INFO -->
          <div class="join-class-btn" v-if="account_type !== 'teacher'">
            <template v-if="isLiveClassOpened">
              <template v-if="isClassSubscribed">
                <div
                  v-if="post_status === 'pending' || post_status === 'ongoing'"
                  class="start-class-btn btn-link font-weight-bold link-no-underline mr-4 rounded-20"
                  :class="
                    !already_joined || post_status === 'pending'
                      ? 'join-class-btn'
                      : 'rejoin-class-btn'
                  "
                  v-on="{
                    click:
                      !already_joined || post_status === 'pending'
                        ? joinUpLiveClass
                        : rejoinLiveClass,
                  }"
                >
                  {{
                    !already_joined || post_status === "pending" ? join : rejoin
                  }}
                </div>

                <div
                  v-else-if="post_status === 'completed'"
                  class="start-class-btn btn-link font-weight-bold opacify link-no-underline mr-4 rounded-20 disabled"
                >
                  Class Closed
                </div>
              </template>

              <template v-else>
                <div
                  class="btn-lock my-1 text-report brand_tonic font-weight-bold my-1"
                >
                  <div class="icon-lock-fill mr-1"></div>
                  <div class="lock-text ml-1">Access Locked</div>
                </div>
              </template>
            </template>

            <template v-else>
              <div
                class="start-class-btn btn-link font-weight-bold opacify link-no-underline mr-4 rounded-20 disabled"
              >
                Class Closed
              </div>
            </template>
          </div>

          <!-- TEACHER VIEW -->
          <div
            class="d-flex justify-content-start align-items-center position-relative"
            style="margin-top: -15px"
            v-if="account_type === 'teacher'"
          >
            <template v-if="isLiveClassOpened">
              <template v-if="!isClassSubscribed">
                <div
                  class="btn-lock my-1 text-report brand_tonic font-weight-bold my-1"
                >
                  <div class="icon-lock-fill mr-1"></div>
                  <div class="lock-text ml-1">Access Locked</div>
                </div>
              </template>

              <template v-else>
                <div
                  v-if="post_status === 'pending'"
                  class="start-class-btn btn-link font-weight-bold link-no-underline mr-4 rounded-20"
                  :class="post.isOwner ? 'start-class-btn' : 'join-class-btn'"
                  v-on="{
                    click: post.isOwner ? startUpLiveClass : joinUpLiveClass,
                  }"
                >
                  {{ post.isOwner ? start : join }}
                </div>

                <template v-else-if="post_status === 'ongoing'">
                  <div
                    class="start-class-btn btn-link font-weight-bold link-no-underline mr-4 rounded-20"
                    :class="
                      already_joined ? 'rejoin-class-btn' : 'join-class-btn'
                    "
                    v-on="{
                      click: already_joined ? rejoinLiveClass : joinUpLiveClass,
                    }"
                  >
                    {{ already_joined ? rejoin : join }}
                  </div>

                  <div
                    class="start-class-btn btn-link font-weight-bold link-no-underline mr-4 rounded-20 end-class-btn"
                    @click="endLiveClass"
                    v-if="post.isOwner"
                  >
                    {{ end }}
                  </div>
                </template>

                <div
                  v-else-if="post_status === 'completed'"
                  class="start-class-btn btn-link font-weight-bold link-no-underline mr-4 rounded-20 opacify disabled"
                >
                  Class Closed
                </div>
              </template>
            </template>

            <template v-else>
              <div
                class="start-class-btn btn-link font-weight-500 opacify link-no-underline mr-4 rounded-20 disabled"
              >
                Class Closed
              </div>
            </template>

            <!-- OPTION -->
            <div
              v-if="false"
              class="avatar pointer more-option"
              :class="!isLiveClassOpened ? 'disabled' : null"
              v-on-clickaway="dropOption"
              @click="toggleEventOption"
            >
              <span
                class="icon-ellipsis-h color_grey_dark font-19 flex-center"
              ></span>
            </div>

            <!-- DROPDOWN MENU -->
            <div class="dropdown-btn-menu placement-bottom" v-if="event_option">
              <ul class="list-unstyled">
                <li>
                  <router-link to>Reschedule</router-link>
                </li>
                <li>
                  <router-link to>Edit Details</router-link>
                </li>
                <li>
                  <router-link to>Cancel Class</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ResponseDialog
      v-if="response_dialog"
      :alert_msg="alert_card_msg"
      :alert_type="alert_card_type"
      @closeAlert="toggleResponseDialog"
    ></ResponseDialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mixin as clickaway } from "vue-clickaway";
import { getShortReadableDate, twelveHoursTime } from "@/scripts/utilities";
import { EventBus } from "@/scripts/event-bus.js";

export default {
  name: "PostEventBlock",

  components: {
    ResponseDialog: () =>
      import(
        /* webpackChunkName: "ResponseDialog" */ "@/components/globalComps/ResponseDialog"
      ),
  },

  props: {
    post: Object,
    subscription_status: Boolean,
  },

  mixins: [clickaway],

  data() {
    return {
      account_type: "",
      event_option: false,

      post_status: this.post.reference.status,

      alert_card_msg: null,
      alert_card_type: null,
      response_dialog: false,

      class_not_started: true,
      remount: false,

      already_joined: localStorage.getItem(this.post.id),

      join: "Join class",
      start: "Start class",
      rejoin: "Rejoin class",
      end: "End class",
    };
  },

  computed: {
    ...mapGetters(["getLiveClassStatus", "getSelectedChildID"]),

    getDateFormat() {
      let scheduled_date = this.post.reference.availability.split(" ");

      let date = getShortReadableDate(scheduled_date[0]);
      let time = twelveHoursTime(scheduled_date[1]);

      return `${date} • ${time}`;
    },

    isLiveClassOpened() {
      let date_ref = new Date();
      let date_format = `${date_ref.getFullYear()}-${date_ref.getMonth() +
        1}-${date_ref.getDate()}`;
      let current_date = new Date(date_format);

      let start_date_ref = this.post.reference.availability.split(" ")[0];
      let close_day = new Date(start_date_ref);

      if (current_date > close_day) return false;
      else return true;
    },

    isClassSubscribed() {
      if (
        this.post?.reference?.category === "tutor" &&
        this.post?.reference?.tutorSessionParticipant.length
      )
        return true;
      else if (this.subscription_status) return true;
      else return false;
    },
  },

  watch: {
    remount: {
      handler(newVal) {
        if (newVal) {
          EventBus.$emit("event-bus-remount-post-list");
          EventBus.$emit("event-bus-remount-upcoming-list");
        }
      },
    },
  },

  mounted() {
    this.getAccountType();
  },

  methods: {
    ...mapActions([
      "startUserLiveClass",
      "joinUserLiveClass",
      "endUserLiveClass",
    ]),

    toggleResponseDialog(msg = "", type = "", toggle = false) {
      this.alert_card_msg = msg;
      this.alert_card_type = type;
      this.response_dialog = toggle;
    },

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
    },

    toggleEventOption() {
      this.event_option = !this.event_option;
    },

    dropOption() {
      this.event_option = false;
    },

    startUpLiveClass() {
      // this.$refs.startClassBtn.innerText = "Starting...";
      this.start = "Starting..";

      this.toggleResponseDialog("Starting live class...", "success", true);

      // START LIVE CLASS
      setTimeout(() => {
        this.startUserLiveClass(this.post.reference.id)
          .then((response) => {
            this.start = "Start class";
            if (response.code === 200) {
              this.post_status = "ongoing";
              localStorage.setItem(this.post.id, true);

              this.already_joined = true;

              // console.log(response.data);
              let a = document.createElement("a");
              a.target = "_blank";
              a.href = response.data;
              a.click();
            }
          })
          .catch((err) => console.log(err));
      }, 1000);

      // setTimeout(() => {
      //   // this.$refs.startClassBtn.innerText = "Start Class";
      //   this.class_not_started = false;
      //   this.remount = !this.remount;
      // }, 3000);
    },

    rejoinLiveClass() {
      // this.$refs.rejoinClassBtn.innerText = "Joining...";
      this.rejoin = "Rejoining...";
      this.toggleResponseDialog("Rejoining live class...", "success", true);

      // REJOIN LIVE CLASS
      setTimeout(() => {
        let class_data = {
          session_id: this.post.reference.id,
          child_id:
            this.account_type === "parent" ? this.getSelectedChildID : null,
        };

        this.joinUserLiveClass(class_data)
          .then((response) => {
            this.rejoin = "Rejoin class";
            // console.log(response);
            if (response.code === 200) {
              let a = document.createElement("a");
              a.target = "_blank";
              a.href = response.data;
              a.click();
            } else {
              localStorage.removeItem(this.post.id);

              this.post_status = "completed";
              this.already_joined = false;

              this.toggleResponseDialog("Class already ended", "error", true);
            }
          })
          .catch((err) => console.log(err));
      }, 1000);

      // setTimeout(() => {
      //   this.$refs.rejoinClassBtn.innerText = "Rejoin Class";
      // }, 3000);
    },

    joinUpLiveClass() {
      // this.$refs.joinClassBtn.innerText = "Joining...";
      this.join = "Joining...";

      this.toggleResponseDialog("Joining live class...", "success", true);

      // JOIN LIVE CLASS
      setTimeout(() => {
        let class_data = {
          session_id: this.post.reference.id,
          child_id:
            this.account_type === "parent" ? this.getSelectedChildID : null,
        };

        this.joinUserLiveClass(class_data)
          .then((response) => {
            this.join = "Join class";
            // console.log(response);
            if (response.code === 200) {
              this.post_status = "ongoing";

              localStorage.setItem(this.post.id, true);
              this.already_joined = true;

              let a = document.createElement("a");
              a.target = "_blank";
              a.href = response.data;
              a.click();
            } else if (response.code === 406) {
              setTimeout(() => {
                localStorage.removeItem(this.post.id);
                this.already_joined = false;

                this.toggleResponseDialog(
                  "Teacher has not started class...",
                  "error",
                  true
                );
              }, 500);
            } else {
              this.post_status = "completed";
              this.toggleResponseDialog("Class already ended", "error", true);
            }
          })
          .catch((err) => console.log(err));
      }, 1000);

      // setTimeout(() => {
      //   // this.$refs.joinClassBtn.innerText = "Join Class";
      // }, 3000);
    },

    endLiveClass() {
      // this.$refs.endClassBtn.innerText = "Ending...";
      this.end = "Ending...";

      this.toggleResponseDialog("Ending live class...", "success", true);

      //END LIVE CLASS
      this.endUserLiveClass(this.post.reference.id)
        .then((response) => {
          this.end = "End class";
          if (response.code === 200) {
            this.post_status = "completed";
          }

          console.log("ending class", response);
        })
        .catch((err) => console.log(err));

      // setTimeout(() => {
      //   this.$refs.endClassBtn.innerText = "Class closed";
      //   this.remount = !this.remount;
      // }, 1500);
    },
  },
};
</script>

<style lang="scss">
.post-event-section {
  border: 1px solid #dbf5f8;
  box-sizing: border-box;
  padding: 10px 10px 14px;
  margin-left: 4px;
  margin-top: 10px;

  @include breakpoint_max(sm) {
    padding: 7.5px 7.5px 9px;
    margin-left: 9px;
  }

  .top-block {
    @include flex_row_start_nowrap;
    align-items: flex-start;

    .avatar {
      margin-right: 13px;
      @include equal_min_edge(40);
      @include breakpoint_max(sm) {
        @include equal_min_edge(32);
      }
    }

    .title {
      font-size: 13.5px;
      line-height: 19px;
      margin-bottom: 5px;
      padding-top: 2px;

      @include breakpoint_max(sm) {
        font-size: 12px;
        line-height: 17px;
      }
    }

    .timing {
      font-size: 13px;
      line-height: 16px;
      margin-bottom: 30px;

      @include breakpoint_max(sm) {
        font-size: 10.5px;
        line-height: 15px;
      }
    }

    .start-class-btn {
      font-size: 13px;
      background: $brand_accent_light;
      border: 1px solid $brand_accent;
      padding: 10px 20px;
      color: $color_ash;
      transition: all 0.3s ease-in-out;
      width: max-content;

      @include breakpoint_max(sm) {
        font-size: 11px;
        padding: 8px 16px;
      }

      &:hover {
        transform: scale(0.96);
        color: $brand_primary !important;
      }
    }

    .btn-lock {
      @include flex_row_center_nowrap;
      padding: 10px 20px;
      position: relative;
      top: 10px;
      font-size: 13px;
      width: max-content;

      .icon-lock-fill {
        font-size: 12px;
      }

      @include breakpoint_max(sm) {
        padding: 8px 16px;
        font-size: 11px;
      }
    }

    .end-class-btn {
      background: $brand_red_light !important;
      border: 1px solid $brand_red !important;
      width: max-content;
    }

    .rejoin-class-btn {
      background: $brand_green_light !important;
      border: 1px solid $brand_green !important;
      width: max-content;
    }

    .more-option {
      border: 1px solid $border_grey;
      transition: all 0.3s ease-in-out;
      @include equal_min_edge(30);

      &:hover {
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
        transform: scale(0.96);
      }
    }

    .join-class-btn {
      margin-top: -10px;
      margin-bottom: 5px;
      width: max-content;
    }
  }

  .dropdown-btn-menu {
    width: 170px;
    @include breakpoint_max(sm) {
      width: 120px;
    }
    a {
      font-size: 11.5px;
      color: $color_grey_dark;
      padding: 9px 5px;

      @include breakpoint_max(sm) {
        font-size: 10.5px;
        padding: 6px 3px;
      }
    }
  }

  .opacify {
    background: $border_grey_light !important;
    border: 1px solid $border_grey !important;
    opacity: 0.7;
  }

  .btn-lock {
    border: 1px solid $brand_red;
    border-radius: 30px;
    cursor: not-allowed !important;
    background: $brand_red_light;

    &:hover {
      border: 1px solid $brand_red;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    }
  }
}
</style>
